export const Events = {
    MODULE_OPENED: 'MODULE_OPENED',
    LEAD_CREATED: 'LEAD_CREATED',
    CALL_CLICKED: 'CALL_CLICKED',
    METRIC_WIDGET_OPENED: 'widget_opened',
    METRIC_LEAD_CREATED: 'lead_created',
    METRIC_CALL_PLACED: 'call_placed',
    CHATBOT_INTERACTED: 'chatbot_interacted'
};

export const Keys = {
    MACHINE_KEY: 'clx_wmmk',
    SESSION_KEY: 'clx_wmsk',
    SESSION_START: 'clx-wmss',
    SESSION_AGE_LIMIT: 1800
};
